import { __awaiter } from "tslib";
import { PositionalScoreAlignmentTrackFactory } from "./PositionalScoreAlignmentTrackFactory";
import { PlainObservedAlignmentTrackFactory } from "./PlainObservedAlignmentTrackFactory";
import { TagDelimiter } from "@rcsb/rcsb-api-tools/lib/RcsbUtils/TagDelimiter";
export class MsaAlignmentTrackFactory {
    constructor(entityInstanceTranslator) {
        this.observedAlignmentTrackFactory = new PlainObservedAlignmentTrackFactory(entityInstanceTranslator);
        this.positionalScoreAlignmentTrackFactory = new PositionalScoreAlignmentTrackFactory(entityInstanceTranslator);
    }
    getTrack(alignmentQueryContext, targetAlignment) {
        return __awaiter(this, void 0, void 0, function* () {
            if (targetAlignment.target_id && TagDelimiter.isEntityOrInstanceId(targetAlignment.target_id))
                return this.observedAlignmentTrackFactory.getTrack(alignmentQueryContext, targetAlignment);
            else
                return this.positionalScoreAlignmentTrackFactory.getTrack(alignmentQueryContext, targetAlignment);
        });
    }
    prepareFeatures(unObservedRegions, positionalScores) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.observedAlignmentTrackFactory.prepareFeatures(unObservedRegions);
            yield this.positionalScoreAlignmentTrackFactory.prepareFeatures(positionalScores);
        });
    }
}
//# sourceMappingURL=MsaAlignmentTrackFactory.js.map